import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import { keysToCamelCase } from '../../../ui-lottery/src/utils/object_utils';
import * as types from '../constants/actions';
import { CurrentUserDefaults } from '../props/currentUser';
import SecurityHelper from '../utils/security';

const login = makeAsyncReducer(types.LOGIN);
const logout = makeAsyncReducer(types.LOGOUT);
const reload = makeAsyncReducer(types.RELOAD);
const update = makeAsyncReducer(types.UPDATE_CURRENT_USER, {
  success: (state, action) => {
    // Ensure that any new user data is properly camelCased before applying it
    const userData = keysToCamelCase(action.payload);
    const apiKey = { ...state.data.apiKey, ...userData.apiKey };
    const data = { ...state.data, ...{ apiKey } };

    // Save the updated apiKey to the session or local store
    SecurityHelper.user(data);
    SecurityHelper.apiKey(apiKey.apiKey);

    return { loading: false, loaded: true, error: null, data };
  }
});

export default mergeReducers(asyncDefaults(CurrentUserDefaults), types.PREFIX, login, logout, reload, update);

export const getCurrentUser = (state) => {
  if (state.portal.currentUser.error) {
    return CurrentUserDefaults;
  }

  if (state.portal.currentUser.loading || !state.portal.currentUser.loaded) {
    return CurrentUserDefaults;
  }

  return state.portal.currentUser.data;
};
